export const cookieSet = new Set();
export const localStorageSet = new Set();
export const sessionStorageSet = new Set();
export function clearAllSets() {
    cookieSet.clear();
    localStorageSet.clear();
    sessionStorageSet.clear();
}
//# sourceMappingURL=set-store.js.map